/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const PaymentStatus = {
  Paid: "paid",
  Unpaid: "unpaid",
  NoPaymentRequired: "no_payment_required",
} as const;
export type PaymentStatus = OpenEnum<typeof PaymentStatus>;

export const GetStripeCheckoutStatusResponseBodyStatus = {
  Open: "open",
  Complete: "complete",
  Expired: "expired",
} as const;
export type GetStripeCheckoutStatusResponseBodyStatus = OpenEnum<
  typeof GetStripeCheckoutStatusResponseBodyStatus
>;

export type GetStripeCheckoutStatusResponseBody = {
  /**
   * Whether this completed session and its own subscription are ready for billing activation; local webhook persistence is still required
   */
  billingReady: boolean;
  paymentStatus: PaymentStatus;
  status: GetStripeCheckoutStatusResponseBodyStatus;
};

/** @internal */
export const PaymentStatus$inboundSchema: z.ZodMiniType<
  PaymentStatus,
  unknown
> = openEnums.inboundSchema(PaymentStatus);

/** @internal */
export const GetStripeCheckoutStatusResponseBodyStatus$inboundSchema:
  z.ZodMiniType<GetStripeCheckoutStatusResponseBodyStatus, unknown> = openEnums
    .inboundSchema(GetStripeCheckoutStatusResponseBodyStatus);

/** @internal */
export const GetStripeCheckoutStatusResponseBody$inboundSchema: z.ZodMiniType<
  GetStripeCheckoutStatusResponseBody,
  unknown
> = z.pipe(
  z.object({
    billing_ready: z.boolean(),
    payment_status: PaymentStatus$inboundSchema,
    status: GetStripeCheckoutStatusResponseBodyStatus$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "billing_ready": "billingReady",
      "payment_status": "paymentStatus",
    });
  }),
);

export function getStripeCheckoutStatusResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<GetStripeCheckoutStatusResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetStripeCheckoutStatusResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetStripeCheckoutStatusResponseBody' from JSON`,
  );
}
